import { Link } from 'react-router';
import type { TileSize } from '../../../tiles/registry';
import { copy } from '../copy';
import { QUIT_BASE } from '../dashboardDefaults';
import { useQuitOverview } from '../hooks';
import { FOCUS } from '../styles';

/** Days under the limit (taper) or smoke-free days (after the quit date). Cumulative: slips never reset it. */
export function StreakTile(_props: { size: TileSize; config: unknown }) {
  const q = useQuitOverview();
  const o = q?.overview;
  if (!o) return <p className="text-sm text-muted">{q ? copy.needPlan : copy.loading}</p>;
  const smokeFree = o.phase === 'smoke_free';
  const main = smokeFree
    ? copy.smokeFreeDays(o.smokeFree.smokeFreeDays)
    : copy.daysUnder(o.limitProgress.daysUnder);
  const sub = smokeFree
    ? copy.sinceQuit(o.smokeFree.daysSinceQuit)
    : o.limitProgress.daysCounted === 0
      ? copy.startsTomorrow
      : copy.bestRun(o.limitProgress.bestRun);
  return (
    <div role="group" aria-label={`${copy.streakTitle}, ${main}`} className="flex flex-col gap-1">
      <Link to={QUIT_BASE} className={`text-xl font-bold text-fg ${FOCUS}`}>
        {main}
      </Link>
      <p className="text-sm text-muted">{sub}</p>
    </div>
  );
}
